module.exports = __webpack_public_path__ + "img/success_1.007118d3.gif";